class AppError {
  constructor(statusCode = 500) {
    this.name = `AppError${statusCode}`
    this.statusCode = statusCode
  }
}

export default AppError
